import { FlexWrapper, Text } from '@intigral/shared';
import { __ } from '../../../translations';

export const QitafDiscountBreakdown = ({
    priceWithVat,
    updatedPrice,
}: {
    priceWithVat: number;
    updatedPrice: number;
}) => {
    if (updatedPrice == null || updatedPrice === priceWithVat) {
        return null;
    }

    return (
        <FlexWrapper
            style={{
                display: 'grid',
                gridTemplateColumns: '1fr auto',
                width: 'fit-content',
                margin: '0 auto',
                gap: '0 calc(var(--step) * 2',
            }}
            justifyContent="end"
        >
            <Text as="span" size="14" color="gray" alignment="end">
                {__('qitaf_movieـrentalـfor_48_hours')}
            </Text>
            <Text as="span" size="14" color="white" style={{ textAlign: 'start' }}>
                <b>{priceWithVat?.toFixed(2)}</b>
                {' ' + __('qitaf_currency')}
            </Text>
            <Text as="span" size="14" color="gray" alignment="end">
                {__('qitaf_one_time_discount')}
            </Text>
            <Text as="span" size="14" color="white" style={{ textAlign: 'start' }}>
                <b>{(priceWithVat - updatedPrice)?.toFixed(2)}</b>
                {' ' + __('qitaf_currency')}
            </Text>
        </FlexWrapper>
    );
};
